import * as React from 'react';

import {colors} from '../colors/colors';

import styles from './progress-donut.module.css';

type Props = {
    percentComplete?: number;
    height?: number;
    color?: string;
    fontColor?: string;
    noPadding?: boolean;
};

export function ProgressDonut(props: Props) {
    const {
        percentComplete = 0,
        height = 100,
        color = colors.green,
        fontColor = colors.greyDk,
    } = props;

    return (
        <div className={props.noPadding ? styles['container--no-padding'] : styles.container}>
            <svg viewBox='0 0 36 36' style={{height}}>
                <path
                    d='M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831'
                    className={styles['circle-background']}
                />
                <path
                    style={percentComplete === 0 ? undefined : {stroke: color}}
                    strokeDasharray={`${percentComplete}, 100`}
                    d='M18 2.0845
          a 15.9155 15.9155 0 0 1 0 31.831
          a 15.9155 15.9155 0 0 1 0 -31.831'
                    className={styles.circle}
                />
                <text x='18' y='20.35' fill={fontColor} className={styles.percentage}>
                    {percentComplete}%
                </text>
            </svg>
        </div>
    );
}
